import { isIncludedByZipRange, parseZipRanges, printContacts } from "./utils";

export const SELECTORS = {
  root: ".js-address-search",
  zipInput: ".zip-search__input",
  zipButton: ".zip-search__button",
  data: ".js-locations-data",
  output: ".js-contact-persons__inner",
};

export default class AddressZipSearch {

  static initAll() {
    document.querySelectorAll(SELECTORS.root).forEach(element => {
      new AddressZipSearch(element)
    })
  }

  constructor(element) {
    this.element = element;
    this.zipInput = this.element.querySelector(SELECTORS.zipInput);
    this.zipButton = this.element.querySelector(SELECTORS.zipButton);
    this.output = this.element.querySelector(SELECTORS.output);

    this.contactPersons = [];

    this.init();
  }

  async init() {
      await this.fetchContactPersons();
      this.getZipSearchContactPersons();
  }

  filterContacts(locations) {
    // ! Filter by postal code or country
    // It is checked whether the current locations are in Germany. If so, the contact persons are searched by zip code area.
    // If the current locations are not in Germany, the contact persons are filtered by country.

    if(!this.contactPersons) {
      return [];
    }

    let availableContacts = this.contactPersons;
    let matchingContacts = [];

    /* remove already matching contacts from available ones and push them to matchingContacts */
    const moveMatches = (matching = []) => {
      availableContacts = availableContacts.filter(person => {
        if (matching.includes(person)) {
          matchingContacts.push(person);
          return false;
        }

        return true;
      });
    }

    for(let location of locations) {
      if(location.country === "DE") {
        let matching = availableContacts.filter(person => isIncludedByZipRange(person.zip_range, location.zip));

        moveMatches(matching);
      }
    }

    return matchingContacts;
  }

  renderContact(contact) {
    return `
        <div class="contact-box">
          <div class="contact-box__profile-image-wrapper">
            <div class="contact-box__profile-image">
              <figure class="figure">
                <img itemprop="image" class="figure-img img-fluid img-thumbnail rounded" loading="lazy" src="/${contact.image}">
              </figure>
            </div>
          </div>
          <div class="contact-box__listing-details">
          ${!contact.company ? `
            <p class="company">${contact.company}</p>
          `: '' }
            <div class="contact-box__name">
              <h4 itemprop="name">${contact.first_name} ${contact.last_name}</h4>
            </div>
            <div class="contact-box__position">
              <p itemprop="jobTitle">${contact.position}</p>
            </div>
            <div class="contact-box__listing-content">
              <div class="digital-contact">
                ${contact.email ? `
                  <div class="digital-contact__item email">
                    <a href="mailto:${contact.email}">
                      <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"></path><path fill="currentColor" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"></path></svg></span>
                      ${contact.email}
                    </a>
                  </div>
                ` : '' }
                ${contact.phone ? `
                  <div class="digital-contact__item phone">
                    <a href="tel:${contact.phone}">
                      <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"></path><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"></path></svg></span>
                      ${contact.phone}
                    </a>
                  </div>
                `: ''}
                ${contact.mobile ? `
                  <div class="digital-contact__item phone--mobile">
                    <a href="tel:${contact.mobile}">
                      <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"></path><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"></path></svg></span>
                      ${contact.mobile}
                    </a>
                  </div>
                `: '' }
              </div>
            </div>
            ${contact.booking_link ? `
              <a class="button button--full-width button--primary button--with-icon-arrow button--with-icon-right address-booking-button" href="${contact.booking_link}">${TYPO3.lang["map.contactPersons.booking"]}</a>
            ` : '' }
          </div>
        </div> 
      `;
  }

  renderNoContacts() {
    return `
        <p>${TYPO3.lang["map.contactPersons.noContactsFound"]}</p>
      `;
  }

  getZipSearchContactPersons() {
    this.zipButton.addEventListener("click", (e) => {
      e.preventDefault();
      const inputValue = this.zipInput.value
      const filteredData = this.filterContacts([{zip: inputValue, country: 'DE'}]);

      let renderOutput = "";

      filteredData.forEach((contact) => {
        renderOutput += this.renderContact(contact)
      });

      this.output.innerHTML = renderOutput;
    })
  }

  async fetchContactPersons() {
    const url = document.querySelector(SELECTORS.data).dataset.url;
    const pidlist = document.querySelector(SELECTORS.data).dataset.sourcePid;
    const recursive = document.querySelector(SELECTORS.data).dataset.recursive;

    let formData = new FormData();
    formData.append('lintemplate_mapaddress[pidlist]', pidlist);
    formData.append('lintemplate_mapaddress[recursive]', recursive);

    let contactPersons = await fetch(url, {
      method: "POST",
      body: formData
    }).then(response => response.json()).catch(err => console.error(err));

    this.contactPersons = contactPersons.map(parseZipRanges);
  }
}

